import React from "react";
import {
    Briefcase,
    Dumbbell,
    Rocket,
    GraduationCap,
    Users,
    Heart,
} from "lucide-react";

const AUDIENCES = [
    { label: "Busy professionals", Icon: Briefcase },
    { label: "Gym-goers", Icon: Dumbbell },
    { label: "Entrepreneurs", Icon: Rocket },
    { label: "Students", Icon: GraduationCap },
    { label: "Families", Icon: Users },
    { label: "Caribbean food lovers", Icon: Heart },
];

export default function BuiltFor() {
    return (
        <section
            data-testid="builtfor-section"
            className="relative overflow-hidden bg-forest text-cream py-20 md:py-28 px-6 sm:px-8"
        >
            {/* subtle decorative accents */}
            <span
                aria-hidden
                className="absolute -top-10 -left-10 w-72 h-72 rounded-full bg-gold/10 blur-3xl pointer-events-none"
            />
            <span
                aria-hidden
                className="absolute -bottom-16 -right-10 w-80 h-80 rounded-full bg-mint/10 blur-3xl pointer-events-none"
            />

            <div className="relative max-w-5xl mx-auto text-center">
                <span
                    data-testid="builtfor-pill"
                    className="inline-block px-4 py-1.5 rounded-full bg-gold/15 border border-gold/30 text-gold text-xs font-bold tracking-widest uppercase"
                >
                    Why Caribbean Meal Prep
                </span>

                <h2
                    data-testid="builtfor-headline"
                    className="mt-6 font-serif font-black text-4xl sm:text-5xl md:text-6xl leading-tight text-cream"
                >
                    Not Your Average{" "}
                    <span className="text-gold italic">Meal Prep</span>
                </h2>

                <p
                    data-testid="builtfor-subcopy"
                    className="mt-6 max-w-2xl mx-auto text-base sm:text-lg text-cream/80 leading-relaxed"
                >
                    We combine bold Caribbean flavor with modern meal prep
                    convenience — so you can eat better without sacrificing
                    taste.
                </p>

                <div className="mt-12 inline-flex items-center gap-2">
                    <span className="h-px w-10 bg-gold/60" />
                    <span className="text-[11px] sm:text-xs tracking-[0.35em] font-bold text-gold uppercase">
                        Built For
                    </span>
                    <span className="h-px w-10 bg-gold/60" />
                </div>

                <ul
                    data-testid="builtfor-audience-list"
                    className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 max-w-3xl mx-auto"
                >
                    {AUDIENCES.map(({ label, Icon }, idx) => (
                        <li
                            key={label}
                            data-testid={`builtfor-audience-${idx}`}
                            className="reveal group flex items-center gap-3 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md px-4 py-3.5 text-left transition-all duration-200 hover:bg-white/10 hover:border-gold/40 hover:-translate-y-0.5"
                            style={{ transitionDelay: `${idx * 60}ms` }}
                        >
                            <span className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-gold/15 ring-1 ring-gold/30 group-hover:bg-gold/25 transition-colors">
                                <Icon
                                    size={18}
                                    strokeWidth={2}
                                    className="text-gold"
                                />
                            </span>
                            <span className="text-sm sm:text-[15px] font-medium text-cream leading-tight">
                                {label}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
